module.exports = __webpack_public_path__ + "img/join_btns.06daaaa3.png";